import {combineReducers} from 'redux';

function filters(state = {}, action) {
    switch (action.type) {
        case 'VOICE_MAIL_FILTER': {
            return action.data;
        }
        default:
            return state;
    }
}

export default combineReducers({
    filters,
});
